<template>
  <div class="Published CommonContentSingle-white" v-loading="loadings">
    <el-button type="primary" @click="toadd"> {{ $t('original.languages69') }}</el-button>
    <ul v-if="Published_list.length > 0">
      <li v-for="item in Published_list" :key="item.DicID">
        <img :src="item.Coverurl" alt="" />
        <div class="pl-list-ct">
          <ul>
            <li>
              <h2>{{ item.PublishSubject }}</h2>
            </li>
            <li style="float: right;">
              <p> {{ $t('original.languages70') }}：{{ item.CreatedDate }}</p>
            </li>
          </ul>
          <ul class="vdjop">
            
            <li style="margin-left: 0px;">
              <p :title="item.DeptName">
                <span class="el-icon-film"></span>
                {{ item.DeptName }}
              </p>
            </li>
            <li>
              <p>{{ $t('original.languages71') }}：{{ item.ValidStartDate }}</p>
            </li>

            <li>
              <p>{{ $t('original.languages72') }}：{{ item.ValidEndDate }}</p>
            </li>

          </ul>
          <ul class="ucdka">

            <li style="width: 300px;">
              <span>{{ $t('original.languages120') }}:</span>
              <el-progress style="width: 200px; display: inline-block; margin-left: 10px;" :stroke-width="26" :percentage="(Number(item.Plan)).toFixed(2)"></el-progress>
            </li>

            <li style="float: right; margin: 0px 10px;">
              <p slot="reference" @click="open(item)" style="color: #e23073;">
               {{ $t('original.delete') }}
              </p>
            </li>

            <li style="float: right; margin: 0px 10px;">
              <p slot="reference" @click="handleClick(item)" style="color: #e23073;"
                v-if="item.Nation == 0 || item.Nation == 1">
                 {{ $t('original.languages73') }}
              </p>
            </li>

            <li style="float: right; margin: 0px 10px;">
              <p @click="onfocus(item.PublishID)" style="color: #409eff;">
                 {{ $t('original.editor') }}
              </p>
            </li>

            <li style="float: right; margin: 0px 10px;"></li>

          </ul>

        </div>
      </li>
    </ul>

    <div class="NoDivData" v-else> {{ $t('original.languages74') }}</div>

    <el-pagination style="margin-top: 20px; text-align: right; margin-bottom: 10px;" :page-size="5" :total="Published_list_num" :current-page="pagesnumber" @current-change="handleCurrentChange"
      layout="total,prev, pager, next" v-if="Published_list.length > 0"></el-pagination>
    <div v-show="drawer">
      <div id="main" style="width: 600px; height: 400px;"></div>
    </div>


    <el-dialog class="dialogVisible" :title="$t('original.languages158')" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <h2> {{ whole_report.DeptName }}</h2>
      <h2> {{ $t('original.languages76') }}</h2>
      <el-button type="primary" @click="daochu" style="float: right;">{{ $t('original.languages154') }} </el-button>
      <div>一、 {{ $t('original.languages77') }}</div>
      <p>{{ $t('original.languages78') }}{{ whole_report.Practical }} {{ $t('original.languages156') }}，{{ $t('original.languages157') }}
        {{ whole_report.NotJoin }} 人。</p>
      <div>二、 {{ $t('original.languages159') }}</div>
      <table class="tbody1" style="border-collapse:collapse;">
        <thead>
          <tr>
            <th>{{ $t('original.The_serial_number') }}</th>
            <th>{{$t('original.languages79')}}</th>
            <th>{{$t('original.languages80')}}</th>
            <th>{{$t('original.languages81')}}</th>
            <th>{{$t('original.languages82')}}</th>
            <th>{{$t('original.languages83')}}</th>
            <th>{{$t('original.languages84')}}</th>
            <th>{{$t('original.languages86')}}</th>
            <th>{{$t('original.languages87')}}</th>
          </tr>
        </thead>
        <tr v-for="item in whole_report.Results" :key="item.index">
          <td>{{ item.no }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.depression }}</td>
          <td>{{ item.anxiety }}</td>
          <td>{{ item.stress }}</td>
          <td>{{ item.selfInflict }}</td>
          <td>{{ item.engt }}</td>
          <td>{{ item.suicideRisk }}</td>
          <td>{{ item.attentiveness }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      whole_report: '',
      PublishID: '',
      loadings: false,
      dialogVisible: false,
      name: 'Echarts',
      aaaaaaaaa: '11',
      drawer: false,
      visible2: false,
      img: require('../../assets/fbfgd.png'),
      Published_list: '',
      Published_list_num: 0,
      pagesnumber: 1,
      Plan: 0,
      option: {},
      options: [
        {
          value: '个体发布',
          label: '个体发布',
        },
        {
          value: '团体发布',
          label: '团体发布',
        },
      ],
      value: '',
    }
  },
  methods: {
    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
        .then((_) => {
          done()
        })
        .catch((_) => { 

        
        })
    },

    handleClick(a, b) {

      this.PublishID = a.PublishID;
      let datas = a.ValidStartDate.substring(0, 4);
      if (a.Nation == 1) {
        if (a.ReportType == 2) {//全校

          this.$router.push(
            {
              path: "/measurement/Mental_health_report",
              query: {PaperResultID:a.PublishID,ReportType:a.ReportType},
            }
          );
          
        } else {//新生
          this.$router.push(
            {
              path: "/measurement/Health_report",
              query: {PaperResultID:a.PublishID,ReportType:a.ReportType},
            }
          );
        }
      } else if (a.Nation == 0) {
        this.$Http_Post('ScaleIssue/GetInternationalStudent',{PublishID:a.PublishID}).then((res) => {
          this.dialogVisible = true
          this.whole_report = res.Data
        })
      }
    },


    // handleClick(a, b) {
    //   this.PublishID = a.PublishID; 
    //   if (a.Nation == 1) {
    //     if (a.ReportType == 2) { 
    //       let routeData = this.$router.resolve({
    //         path: '/visitors/zReportnewShow',
    //         query: {PaperResultID: a.PublishID,ReportType :a.ReportType},
    //       })
    //       window.open(routeData.href, '_blank')
    //     } else {
    //       let routeData = this.$router.resolve({
    //         path: '/visitors/zReportShow',
    //         query: {PaperResultID: a.PublishID,ReportType: a.ReportType},
    //       })
    //       window.open(routeData.href, '_blank')
    //     }
    //   } else if (a.Nation == 0) {
    //     this.$Http_Post('ScaleIssue/GetInternationalStudent', {
    //       PublishID: a.PublishID,
    //     }).then((res) => {
    //       this.dialogVisible = true
    //       this.whole_report = res.Data
    //     })
    //   }
    // },


    daochu() {
      this.$Http_Post('ScaleIssue/GetInternationalStudentWord', {
        PublishID: this.PublishID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank')
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    onfocus: function (fromid) {
      this.$router.push({
        path: '/measurement/Modifyadd',
        query: { param: fromid },
      })
    },
    toadd() {
      this.$router.push('add')
    },
    open(item) {
      this.$confirm(this.$t('original.languages90'), this.$t('original.languages63'), {
        confirmButtonText: this.$t('original.languages59'),
        cancelButtonText: this.$t('original.cancel'),
        type: 'warning',
      })
      .then(() => {
        this.$Http_Post('ScaleIssue/DeScale', { PublishID: item.PublishID }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message)
            } else {
              this.Global.request_failure(res.Message)
            }
            this.loading(1, '')
            this.pagesnumber = 1
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.message,
            })
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    drawers(PublishID) {
      //详情
      this.drawer = !this.drawer
    },
    changeValue() {
      this.loading(1, this.value)
    },
    loading(val, type) {
      this.loadings = true
      this.$Http_Post('ScaleIssue/GetScaleIssue', {
        Condition: '0',
        pageSize: '5',
        pageIndex: val,
        PublishSubject: '',
      })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Published_list = res.Data;
          this.Published_list_num = Number(res.Counts);
          this.loadings = false;
        }
      })
      .catch((err) => {
        this.loadings = false
        this.$message({
          type: 'error',
          message: err.message,
        })
      })
    },
    handleCurrentChange(val) {
      //分页点击事件
      this.loading(val, this.value)
    },
  },
  created() {
    this.loading(1, '')
  },
  mounted() {
    var myChart = this.$echarts.init(document.getElementById('main'))
    myChart.setOption(this.option)
  },
}
</script>
<style>
.Published>ul>li {width: 99.7%;height: 164px;margin-top: 10px;border-bottom: 1px solid #d3d3d3;}
.Published>ul>li>img {margin-top: 20px;float: left;width: 212px;height: 120px;}
.Published>ul>li>.pl-list-ct {margin-top: 20px;float: right;width: calc(100% - 260px);height: 120px;margin-top: 20px;margin-left: 20px;}
.Published>ul>li ul li {font-size: 14px;float: left;color: rgba(92, 92, 92, 1);}
.Published>ul>li ul {height: 50px;}
.Published>ul>li ul li h2 {font-size: 18px;}
.Published>ul>li ul li p {font-size: 14px;color: rgba(92, 92, 92, 1);}
.Published .el-progress-bar__outer {height: 6px;background-color: rgba(36, 153, 255, 0.1);position: relative;vertical-align: middle;border-radius: 0px !important;height: 16px !important;}
.Published .el-progress-bar__inner {border-radius: 0px !important;height: 15px !important;}
.Published .vdjop li {margin: 0px 20px;}
.Published .el-popover {margin-left: -153px;}
.Published .el-popover span {width: 50px;height: 20px;background-color: #fdfdfd;border: 1px solid #d3d3d3;display: inline-block;line-height: 20px;text-align: center;margin-left: 10px;cursor: pointer;}
.Published li p {color: rgba(0, 136, 255, 1);cursor: pointer;}
.Published .ucdka>li .el-progress__text {font-size: 14px !important;width: 45px;}
.Published .vdjop p span {font-size: 16px;}
.Published .vdjop p {width: 210px;cursor: pointer;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.Published .el-icon-s-custom {font-size: 16px;}
.Published .el-progress-bar__innerText {color: #000;font-size: 12px;margin: 0 5px;}
.Published .vdjop li {position: relative;}
.Published .vdjop .Qrcode {width: 100px;height: 100px;position: absolute;top: 50px;left: 0px;z-index: 9999;display: none;}
.Published .sssxsxs:hover~.Qrcode {display: block;}
.Published .sssxsxs {cursor: pointer;}
.Published .el-descriptions :not(.is-bordered) td,
.Published .el-descriptions :not(.is-bordered) th {padding-bottom: 0px;}
.Published .el-descriptions-item__container {line-height: 40px;margin-left: 10px;}
.Published .dialogVisible h2 {text-align: center;margin-top: 10px;}
.Published .dialogVisible div {margin-top: 10px;font-size: 16px;}
.Published .dialogVisible p {margin-top: 10px;line-height: 30px;text-indent: 20px;font-size: 16px;}
.Published .dialogVisible table {text-align: center;margin: auto;margin-top: 20px;margin-bottom: 30px;border: none;}
.Published .dialogVisible table td {padding: 10px;border: 1px rgb(228, 228, 228) solid;}
.Published .dialogVisible table th {padding: 10px;border: 1px rgb(228, 228, 228) solid;background-color: antiquewhite;}
</style>
